import { render, staticRenderFns } from "./VNoteLogbook.vue?vue&type=template&id=7137fbb4"
import script from "./VNoteLogbook.vue?vue&type=script&lang=js"
export * from "./VNoteLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports